
import Layers from "slotworks/graphics/layers/layers";

export function ShowAllMenusCommand() {
    Layers.Menus.show();
    Layers.MenusContent.show();
    Layers.PaytableContent.show();
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/menus/show-all-menus-command.ts